import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { themeColor } from '@edulastic/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${themeColor};
  font-weight: 600;
  font-size: 12px;
  user-select: none;
  white-space: nowrap;
  text-wrap: wrap;
`

export const StyledLink = styled(Link)`
  display: inline-block;

  /* Override any global focus styles */
  &:focus {
    outline: 1px solid ${themeColor} !important;
    outline-offset: 1px !important;
    border-radius: 4px;
    box-shadow: none !important;
  }

  &:focus-visible {
    outline: 1px solid ${themeColor} !important;
    outline-offset: 1px !important;
    border-radius: 4px;
    box-shadow: none !important;
  }

  /* Override global .isKeyboardUser a:focus styles */
  &.isKeyboardUser:focus,
  &.isKeyboardUser:focus-visible {
    outline: 1px solid ${themeColor} !important;
    outline-offset: 1px !important;
    border-radius: 4px;
    box-shadow: none !important;
  }

  /* Maximum specificity to ensure our styles take precedence */
  &:focus,
  &:focus-visible,
  &.isKeyboardUser:focus,
  &.isKeyboardUser:focus-visible {
    outline: 1px solid ${themeColor} !important;
    outline-offset: 1px !important;
    border-radius: 4px;
    box-shadow: none !important;
  }
`

export const SpaceElement = styled.div`
  display: inline-block;
  width: 4px;
`
